import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEmailFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M4.8 4.25C3.38579 4.25 2.25 5.38579 2.25 6.8C2.25 6.83391 2.25225 6.86729 2.25661 6.9C2.25225 6.93271 2.25 6.96609 2.25 7V17C2.25 18.5142 3.48579 19.75 5 19.75H19C20.5142 19.75 21.75 18.5142 21.75 17V7C21.75 6.96609 21.7477 6.93271 21.7434 6.9C21.7477 6.86728 21.75 6.83391 21.75 6.8C21.75 5.38579 20.6142 4.25 19.2 4.25H4.8ZM3.75 7.36775V9.39078L8.31326 12.4444L3.75024 17.0247C3.76359 17.6993 4.32246 18.25 5 18.25H5.01878L9.7229 13.3333C11.241 14.1111 12.9759 14.2222 14.494 13.3333L19.1849 18.2362C19.7814 18.1462 20.2454 17.6282 20.25 17.0092L15.9036 12.5556L20.25 9.52325V7.37022L14.0602 11.7778C12.8675 12.5556 11.3494 12.5556 10.0482 11.7778L3.75 7.36775Z",
		fill: "#111827"
	})
});
const ForwardRef = forwardRef(SvgEmailFilled);
export default ForwardRef;
